module.exports = __webpack_public_path__ + "img/bus-purple.ec71ca41.svg";